// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"4c43f595","244":"03ea1136","300":"f5c9aa37","318":"ae16122e","835":"50494389","970":"82d83e77"}[chunkId] + ".chunk.js";
};